import { render } from "./CurrencyItem.vue?vue&type=template&id=7e21e418&scoped=true&ts=true"
import script from "./CurrencyItem.vue?vue&type=script&lang=ts"
export * from "./CurrencyItem.vue?vue&type=script&lang=ts"

import "./CurrencyItem.vue?vue&type=style&index=0&id=7e21e418&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e21e418"]])

export default __exports__